"use strict";

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("./constants");

var constants_2 = require("../tests/constants");

var rxjs_1 = require("rxjs");

var ChannelClient = /*#__PURE__*/function () {
  function ChannelClient(provider) {
    var _this = this;

    _classCallCheck(this, ChannelClient);

    this.provider = provider;
    this.channelState = new rxjs_1.ReplaySubject(1);
    this.provider.on('ChannelUpdated', function (result) {
      return _this.channelState.next(result);
    });
  }

  _createClass(ChannelClient, [{
    key: "onMessageQueued",
    value: function onMessageQueued(callback) {
      var _this2 = this;

      this.provider.on('MessageQueued', callback);
      return function () {
        _this2.provider.off('MessageQueued', callback);
      };
    }
  }, {
    key: "onChannelUpdated",
    value: function onChannelUpdated(callback) {
      return this.channelState.subscribe(callback).unsubscribe;
    }
  }, {
    key: "onChannelProposed",
    value: function onChannelProposed(callback) {
      var _this3 = this;

      this.provider.on('ChannelProposed', callback);
      return function () {
        _this3.provider.off('ChannelProposed', callback);
      };
    }
  }, {
    key: "onBudgetUpdated",
    value: function onBudgetUpdated(callback) {
      var _this4 = this;

      this.provider.on('BudgetUpdated', callback);
      return function () {
        _this4.provider.off('BudgetUpdated', callback);
      };
    }
  }, {
    key: "getChannels",
    value: function getChannels(includeClosed) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.provider.send({
                  method: 'GetChannels',
                  params: {
                    includeClosed: includeClosed
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "createChannel",
    value: function createChannel(participants, allocations, appDefinition, appData, fundingStrategy) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.provider.send({
                  method: 'CreateChannel',
                  params: {
                    participants: participants,
                    allocations: allocations,
                    appDefinition: appDefinition,
                    appData: appData,
                    fundingStrategy: fundingStrategy
                  }
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "joinChannel",
    value: function joinChannel(channelId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.provider.send({
                  method: 'JoinChannel',
                  params: {
                    channelId: channelId
                  }
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "updateChannel",
    value: function updateChannel(channelId, participants, allocations, appData) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.provider.send({
                  method: 'UpdateChannel',
                  params: {
                    channelId: channelId,
                    participants: participants,
                    allocations: allocations,
                    appData: appData
                  }
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "getState",
    value: function getState(channelId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.provider.send({
                  method: 'GetState',
                  params: {
                    channelId: channelId
                  }
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "challengeChannel",
    value: function challengeChannel(channelId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.provider.send({
                  method: 'ChallengeChannel',
                  params: {
                    channelId: channelId
                  }
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "closeChannel",
    value: function closeChannel(channelId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.provider.send({
                  method: 'CloseChannel',
                  params: {
                    channelId: channelId
                  }
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "pushMessage",
    value: function pushMessage(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.provider.send({
                  method: 'PushMessage',
                  params: message
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "approveBudgetAndFund",
    value: function approveBudgetAndFund(receiveCapacity, sendCapacity, hubAddress, hubOutcomeAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this.provider.send({
                  method: 'ApproveBudgetAndFund',
                  params: {
                    requestedReceiveCapacity: receiveCapacity,
                    requestedSendCapacity: sendCapacity,
                    token: constants_2.ETH_TOKEN_ADDRESS,
                    playerParticipantId: this.signingAddress,
                    hub: {
                      participantId: constants_1.HUB.participantId,
                      signingAddress: hubAddress,
                      destination: hubOutcomeAddress
                    }
                  }
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "getBudget",
    value: function getBudget(hubAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", this.provider.send({
                  method: 'GetBudget',
                  params: {
                    hubAddress: hubAddress
                  }
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "closeAndWithdraw",
    value: function closeAndWithdraw(hubAddress, hubOutcomeAddress) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", this.provider.send({
                  method: 'CloseAndWithdraw',
                  params: {
                    playerParticipantId: this.signingAddress,
                    hub: {
                      participantId: constants_1.HUB.participantId,
                      signingAddress: hubAddress,
                      destination: hubOutcomeAddress
                    }
                  }
                }));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "signingAddress",
    get: function get() {
      return this.provider.signingAddress;
    }
  }, {
    key: "destinationAddress",
    get: function get() {
      return this.provider.destinationAddress;
    }
  }, {
    key: "walletVersion",
    get: function get() {
      return this.provider.walletVersion;
    }
  }]);

  return ChannelClient;
}();

exports.ChannelClient = ChannelClient;